import React from "react"
import { Flex } from "@capioweb/ui-components"
import { ContentAreaProperty } from "../../@types/CapioWeb/core"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import { getContentByType } from "../Core"
import { READABLE_LINE_MAX_WIDTH } from "@capioweb/ui-components/src"

interface ContentHubSelectedArticlesBlockProps {
	heading: StringProperty
	preamble: StringProperty
	mainContentArea: ContentAreaProperty
}

const ContentHubSelectedArticlesBlock: React.FC<ContentHubSelectedArticlesBlockProps> =
	({ preamble, mainContentArea, ...rest }) => {
		return (
			<BlockCommonLayout description={preamble} {...rest}>
				<Flex
					w={1}
					flexWrap="wrap"
					justifyContent="space-between"
					alignContent="space-between"
					columnGap={{ m: 3 }}
					rowGap={{ _: 2, m: 3 }}
				>
					{mainContentArea?.value?.map((block, i) => {
						const { id } = block.contentLink
						const blockType = getContentByType(block.modelType)

						return (
							<Flex
								key={id}
								flexGrow={1}
								flexShrink={i >= 5 ? 0 : 1}
								maxw={
									mainContentArea?.value?.length === 1
										? READABLE_LINE_MAX_WIDTH
										: i === mainContentArea.value.length - 1
										? { m: "calc(50% - 24px)", l: "calc(100% / 3 - 24px)" }
										: {}
								}
								flexBasis={{
									_: "100%",
									m: i === 0 ? "100%" : "calc(50% - 24px)",
									l:
										i === 0
											? "calc(100% / 3 * 2 - 12px)"
											: "calc(100% / 3 - 24px)",
								}}
							>
								{React.createElement(blockType, {
									...(block && typeof blockType === "function" && block),
									key: id,
								})}
							</Flex>
						)
					})}
				</Flex>
			</BlockCommonLayout>
		)
	}

export { ContentHubSelectedArticlesBlock }
